import      React,
            {useState, 
            useEffect, 
            useRef, 
            useMemo}                            from "react";
import {    AgGridReact}                        from "ag-grid-react";
import {    AllCommunityModule,ModuleRegistry}  from 'ag-grid-community';
import {    AG_GRID_LOCALE_BR}                  from '@ag-grid-community/locale';
import {    GetSystemLabel,
            GetAppLang, }                       from "Utilities/utils";
import      Style                               from "../UI/main.module.scss";
import {    InputGeneral}                       from "../Field/field";

export const TableGrid  = React.memo(({...setProps})    => {
    const { columnDefs,
            rowData,
            searchText,  
            setSearchText,
            gridContext,
            Options = {},
            externalRef = null,
        }                                        = setProps;
    const [isReady, setIsReady]                  = useState(false);

    ModuleRegistry.registerModules([AllCommunityModule]);

    const internalRef = useRef();
    const resolvedRef = externalRef || internalRef;

    const gridOptions = useMemo(() => ({
        pagination: true, // Enable pagination
        paginationPageSize: 20, // Number of rows per page
        localeText: GetAppLang() === "Pt" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true,
        ...Options,
    }), [Options]);
        
    useEffect(() => {
        if (!isReady && columnDefs?.length > 0) {
            setIsReady(true);
        }
    }, [columnDefs, isReady]);

    const containerStyle    = useMemo(() => ({ width: "100%",   height: "75vh"  }), []);
    const gridStyle         = useMemo(() => ({ height: "100%",  width: "100%"   }), []);

    return (
        <React.Fragment>
            <div className={[Style.card_bg, Style.shadow_sm, Style.rounded].join(" ")}>
                <div className={[Style.p_3].join(" ")}>
                    <div className={Style.row}>
                        <div className={Style.col_lg}/>
                        <div className={[Style.col_lg_3, Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>
                                <div className={[Style.me_3].join(" ")}>
                                    <svg 
                                        xmlns="http://www.w3.org/2000/svg" 
                                        viewBox="0 0 512 512"
                                        className={Style.small_ico_search_bar}
                                    >
                                        <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                    </svg>
                                </div>
                                <InputGeneral 
                                    value={searchText}
                                    className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                    onChange={(e) => {setSearchText(e.target.value);}}
                                    placeholder={GetSystemLabel("Search")}
                                />
                        </div>
                    </div>
                </div>
                <div style={containerStyle}>
                    <div style={gridStyle}>
                        <AgGridReact 
                            ref={resolvedRef}
                            rowData={rowData}
                            columnDefs={columnDefs}
                            gridOptions={gridOptions}
                            quickFilterText={searchText}
                            context={gridContext}
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
});
